import { UseQueryOptions } from 'react-query';
import { SMSSenderProfile } from 'domains/content/types';
import { CuredApiPaths } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';

type UseSMSSenderProfilesParams = {
    reactQueryOptions?: UseQueryOptions<SMSSenderProfile[], Error>;
    type?: 'sms';
};

/**
 * Returns a react query hook containing the SMS sender profiles data.
 * @param type - Optional 'sms' string to filter sender profiles.
 * @param reactQueryOptions - Optional react-query options.
 * @returns A react query hook with SMS sender profiles data.
 */
const useSMSSenderProfiles = ({ reactQueryOptions, type }: UseSMSSenderProfilesParams = {}) =>
    useQuery<SMSSenderProfile[]>(
        QueryKeys.SENDER_PROFILES(type),
        `${CuredApiPaths.SENDER_PROFILES}${type ? `/${type}` : ''}`,
        reactQueryOptions
    );

export default useSMSSenderProfiles;
